import React from 'react';
import {getBoxes} from '../../services/api/apiBox';
import Loading from '../../components/Loading/Loading';
import BoxesList from './BoxesList';

class BoxesPage extends React.Component {
    state = {
        boxes: [],
        loading: true
    };

    componentDidMount() {
        this.fetchBoxes();
    }

    fetchBoxes = async () => {
        try {
            const {data: dataRes} = await getBoxes();
            const {success, data, message} = Object.assign({}, dataRes);
            if (!success) throw new Error(message);

            this.setState({boxes: data, loading: false});
        } catch (e) {
            alert(e.message);
            this.setState({loading: false});
        }
    };

    render() {
        const {boxes, loading} = this.state;

        if (loading) return <Loading/>;

        return (
            <div className="BoxesPage">
                <BoxesList boxes={boxes}/>
            </div>
        );
    }
}

export default BoxesPage;
